module.exports = __webpack_public_path__ + "media/images/flags/32/Azerbaijan-40b3c4c86ba4dbfc3acb36eef538ffbd.png";